import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import eventDetailsReducer from '../reducers/eventDetailsReducer';

const configureStore = (railsProps) => (
  createStore(eventDetailsReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
